export const paymentProperties = {
    PAYMENT_ENVIRONMENT_KEY : {
        STAGING : "rzp_test_BhzfyCo1rS8oJu",
        PRODUCTION : "rzp_live_NVcIfL87bO1dcx"
    }
}